"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateProjectStatus = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
const updateProjectStatusRuleSet = {
  type: value => value === 'UPDATE_PROJECT_STATUS',
  status: value => typeof value === 'string' && ['IN_PROGRESS', 'ADMIN_EDITING', 'IN_CART', 'PRINTED', 'TRANSLATING', 'FAILED_TRANSLATION'].includes(value)
};
const isUpdateProjectStatus = p => (0, ProjectAction_1.isBaseProjectAction)(p) && (0, typeguard_1.isType)(p, updateProjectStatusRuleSet);
exports.isUpdateProjectStatus = isUpdateProjectStatus;